import clsx from "clsx";

export const DashedBadge: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        "text-sm font-bold text-blackout border rounded-full border-dashed py-1 px-3 flex justify-center items-center text-center",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
